import { DollarCircleOutlined, InfoCircleOutlined } from "@ant-design/icons";
import { Tour, TourProps, Typography, theme } from "antd";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AuditOutlined, FileSearchOutlined, HomeOutlined } from "src/assets/icons";
import Header from "src/components/Header";
import DesktopMenu from "src/components/Menu/DesktopMenu/DesktopMenu";
import { RoutingContext } from "src/contexts";
import { useGlobalContext } from "src/contexts/global.context";
import { useStores } from "src/hooks";
import { MenuProps, observer } from "src/modules";
import { Routes } from "src/routes";
import { capitalizeFirstLetter, dictionary, i18n } from "src/utils";
import { ChildrenContent, Wrapper, WrapperContent } from "./styles";

const { Text } = Typography;

export type MenuItem = Required<MenuProps>["items"][number];

function getItem(
  label: React.ReactNode,
  key: React.Key,
  icon?: React.ReactNode,
  children?: MenuItem[],
  onClick?: () => void,
): MenuItem {
  return {
    key,
    icon,
    children,
    label,
    className: "admissao-frontend-left-menu-item-" + key,
    onClick,
  } as MenuItem;
}

const { useToken } = theme;

const DefaultLayout = ({ children }: { children: React.ReactNode }) => {
  const { isYappUser } = useGlobalContext();

  // contextos
  const { title, subtitle } = useContext(RoutingContext);
  // armazenamentos
  const { navigation } = useStores();
  // navegação
  const navigate = useNavigate();
  // estados
  const [collapsed, setCollapsed] = useState(false);
  const [isPortraitOrientation, setIsPortraitOrientation] = useState<boolean>(false);
  const [showMenu, setShowMenu] = useState<boolean>(true);
  const { token } = useToken();
  const ref1 = useRef(null);
  const ref2 = useRef(null);
  const ref3 = useRef(null);
  const ref4 = useRef(null);

  const [open, setOpen] = useState<boolean>(false);

  const year = new Date().getFullYear();

  const menuItems: MenuItem[] = [
    getItem(i18n(dictionary.homePage), "1", <HomeOutlined />, undefined, () => {
      navigate(Routes.HOME);
    }),
    getItem(<Text ref={ref2}>{i18n(dictionary.label.registration)}</Text>, "sub1", <AuditOutlined />, [
      getItem(capitalizeFirstLetter(i18n(dictionary.label.document, { count: 2 })), "3", null, undefined, () => {
        navigate(Routes.DOCUMENT);
      }),
      getItem(capitalizeFirstLetter(i18n(dictionary.entity.employment_relationships)), "2", null, undefined, () => {
        navigate(Routes.DOCUMENTATION);
      }),
      getItem(capitalizeFirstLetter(i18n(dictionary.entity.admission_flow)), "9", null, undefined, () => {
        navigate(Routes.ADMISSION_FLOW);
      }),
      getItem(capitalizeFirstLetter(i18n(dictionary.entity.employer, { count: 2 })), "4", null, undefined, () => {
        navigate(Routes.EMPLOYER);
      }),
      getItem(capitalizeFirstLetter(i18n(dictionary.entity.employee, { count: 2 })), "5", null, undefined, () => {
        navigate(Routes.EMPLOYEE);
      }),
      // getItem(capitalizeFirstLetter(i18n(dictionary.entity.user)), "6"),
    ]),
    getItem(i18n(dictionary.label.report, { count: 2 }), "sub2", <FileSearchOutlined />, [
      getItem(i18n(dictionary.label.registrationForm, { count: 2 }), "7", null, undefined, () => {
        navigate(Routes.REPORT_REGISTRATION_FORM);
      }),
    ]),
    getItem(i18n(dictionary.label.finance), "8", <DollarCircleOutlined />, undefined, () => {
      navigate(Routes.FINANCE);
    }),
    // getItem(<Text ref={ref3}>{i18n(dictionary.communication)}</Text>, "sub3", <NotificationOutlined />, []),
    // getItem(<Text ref={ref4}>{i18n(dictionary.integration)}</Text>, "sub4", <AppstoreAddOutlined />, []),
  ];

  const steps: TourProps["steps"] = [
    {
      title: (
        <>
          {" "}
          <InfoCircleOutlined /> Tudo sobre controle
        </>
      ),
      description: "Acompanhe mensagens, lembretes e alertas de forma simples e organizada por ordem cronológica.",
      target: () => ref1.current,
      placement: "bottomRight",
    },
    {
      title: (
        <>
          {" "}
          <InfoCircleOutlined /> Título de exemplo
        </>
      ),
      description: "Conteúdo descritivo será desenvolvido de acordo com as seções descritas ao lado.",
      target: () => ref2.current,
      placement: "leftTop",
    },
    {
      title: (
        <>
          {" "}
          <InfoCircleOutlined /> Título de exemplo
        </>
      ),
      description: "Conteúdo descritivo será desenvolvido de acordo com as seções descritas ao lado.",
      target: () => ref3.current,
      placement: "leftTop",
    },
    {
      title: (
        <>
          {" "}
          <InfoCircleOutlined /> Título de exemplo
        </>
      ),
      description: "Conteúdo descritivo será desenvolvido de acordo com as seções descritas ao lado.",
      target: () => ref4.current,
      placement: "leftTop",
    },
  ];

  function handleClickLogo() {
    setCollapsed(!collapsed);
  }

  useEffect(() => {
    // Caso a altura da tela seja maior que a largura
    const isPortraitOrientation = window.innerHeight > window.innerWidth;
    setIsPortraitOrientation(isPortraitOrientation);
    if (isPortraitOrientation) {
      setShowMenu(false);
      setCollapsed(false);
    }
  }, []);

  return (
    <>
      <Wrapper>
        <DesktopMenu />
        <WrapperContent className="dashboard-layout">
          {!isYappUser && (
            <Header
              title={title}
              subtitle={subtitle}
              tourRef={ref1}
              menuItems={menuItems}
              hasLogo={!collapsed}
              onClickLogo={() => handleClickLogo()}
            />
          )}
          <ChildrenContent
            className="custom-content"
            $isYappUser={isYappUser}
          >
            {children}
          </ChildrenContent>
        </WrapperContent>
      </Wrapper>
      <Tour
        open={open}
        onClose={() => setOpen(false)}
        steps={steps}
      />
    </>
  );
};

export default observer(DefaultLayout);
